function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect } from 'react';
import { Pagination as RKSPagination } from '@uncinc/uncinc-react-kitchen-sink';
import { usePagination } from 'react-instantsearch-core';
import './style.scss';

// This needs to be updated in the kitchen sink as an exported type.
// Then extended by this component rather than just redefining them.
// https://uncinc.monday.com/boards/99020894/pulses/9089087381
const SearchPagination = props => {
  const {
    previousLabel,
    nextLabel,
    disableScrollTo = false,
    scrollToPositionTop = 0
  } = props;
  const pagination = usePagination();

  // Ensure we scroll to top when the page changes.
  useEffect(() => {
    if (!disableScrollTo) {
      window.scrollTo({
        top: scrollToPositionTop,
        behavior: 'smooth'
      });
    }
  }, [disableScrollTo, scrollToPositionTop, pagination.currentRefinement]);
  return /*#__PURE__*/React.createElement(RKSPagination, _extends({}, props, {
    currentPage: pagination.currentRefinement + 1,
    totalPages: pagination.nbPages,
    setCurrentPage: page => pagination.refine(page - 1),
    previousLabel: previousLabel,
    nextLabel: nextLabel,
    controlled: true
  }));
};
export default SearchPagination;